import { t } from "@lingui/macro";
import { useLingui } from "@lingui/react";
import { Form, message, Modal } from "antd";
import AuthActions from 'bukku/redux/Auth/actions';
import NotificationActions from 'bukku/redux/Notification/actions';
import React, { useCallback, useEffect } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import ModalContent from "./ModalContent";
import { StyledModal } from "./styles";
import { usePollingTimer } from '../../../helpers/usePollingTimer';
import { CookiesHelper } from '../../../helpers/CookiesHelper';
import { CookieKey } from "../../../enums/CookieKey";
import dayjs from 'dayjs';
import { AppModalType } from "../../../enums/AppModalType";
import AppActions from 'bukku/redux/App/actions';

const {
    openAppModal, closeAppModal,
} = AppActions;
const {
    // reauthenticate,
    login, logout,
} = AuthActions;
const {
    closeDropdown,
} = NotificationActions;

const selectorFn = state => ({
    sessionReady: state.Auth.sessionReady,
    user: state.User.user,
    isPushing: state.App.isPushing,
    isModalVisible: state.App.appModal[AppModalType.SESSION_EXPIRED_MODAL].isVisible,
});

export const isSessionExpiredDebug = false;

const POLLING_INTERVAL_SECONDS = isSessionExpiredDebug ? 1 : 60; // timer refresh every 1sec or 1 minute
const POLLING_INTERVAL_MILLISECONDS = POLLING_INTERVAL_SECONDS * 1000;
// const TRIGGER_VISIBILITY_BELOW_MINUTE = 60; // will show in sidebar when <= 1 hour
// const EXTEND_MINUTE = 60; // when click extend -> 1 hour
const MOMENT_TIME_UNIT = 'seconds';

export default function SessionExpiredModal() {
    useLingui();
    const dispatch = useDispatch();
    const [form] = Form.useForm();

    const {
        sessionReady,
        user,
        isPushing,
        isModalVisible,
    } = useSelector(selectorFn, shallowEqual);

    // timer will not be cleared and will be ticking to detect cross-tab login
    const checkSessionValid = useCallback(timer => {
        const accessToken = CookiesHelper.getCookie(CookieKey.access_token);
        const expiry = dayjs(CookiesHelper.getCookie(CookieKey.session_expiry));
        const diff = expiry.diff(dayjs(), MOMENT_TIME_UNIT);
        if (isSessionExpiredDebug)
            console.log('aaa checkSessionValid', {timer, sessionReady, accessToken, diff});
        if (sessionReady && !accessToken && !isModalVisible) {
            // clearInterval(timer);
            // message.error(t`Access token is missing. Please login again.`);
            // dispatch(logout());
            dispatch(closeAppModal(AppModalType.IDLE_MODAL));
            dispatch(openAppModal(AppModalType.SESSION_EXPIRED_MODAL));
            // const expiredWarning = new SessionExpiredMessage();
            // expiredWarning.show();
        }
        if (accessToken)
            dispatch(closeAppModal(AppModalType.SESSION_EXPIRED_MODAL));
            // clearInterval(timer);
    }, [dispatch, sessionReady, isModalVisible]);

    // Poll every 60 seconds to check if the session is still valid
    // Adapted from SessionTimeoutTimer.js (useEffect)
    usePollingTimer(POLLING_INTERVAL_MILLISECONDS, checkSessionValid, []);

    useEffect(() => {
        // close notification dropdown to prevent UI conflict
        if (isModalVisible)
            dispatch(closeDropdown());
    }, [isModalVisible, dispatch]);

    const prepareFormData = data => ({
        ...data,
        email: data.email.toLowerCase(),
        remember: data.remember || false,
    });

    const handleOk = () => {
        form.validateFields()
            .then(() => {
                // const requestData = form.current.getFieldsValue();

                const urlMode = process.env.REACT_APP_URL_MODE;
                const urlDomain = process.env.REACT_APP_URL_DOMAIN;
                const {hostname} = window.location;
                // const { login } = this.props;

                const requestData = prepareFormData(form.getFieldsValue());

                // Inject subdomain for subdomain mode.
                if (urlMode === 'subdomain' && hostname !== `app.${urlDomain}`)
                    requestData.subdomain = hostname.substr(0, hostname.indexOf(urlDomain) - 1);
                else
                    requestData.subdomain = requestData.subdomain.toLowerCase();

                // dispatch(reauthenticate(requestData));
                dispatch(login(requestData));
            })
            .catch(e => {
                if (e.message)
                    message.error(e.message);
            });
    };

    const handleCancel = () => {
        dispatch(logout());
        Modal.destroyAll(); // closes all modal such as lastVisited
    };

    console.log('aaa render SessionExpiredModal', {isModalVisible});
    return (
        <StyledModal
            open={isModalVisible}
            okText={t`Login`}
            okButtonProps={{
                loading: isPushing,
            }}
            cancelText={t`Logout`}
            onOk={handleOk}
            onCancel={handleCancel}
            zIndex={1005}
            cancelButtonProps={{
                loading: isPushing,
            }}
            maskClosable={false}
            maskStyle={{
                backdropFilter: `blur(3px)`,
                WebkitBackdropFilter: `blur(3px)`,
            }}
            closable={false}
            keyboard={false}
            destroyOnClose
        >
            <ModalContent form={form} handleOk={handleOk} user={user} isModalVisible={isModalVisible} />
        </StyledModal>
    );
}
